import * as React from 'react'
import { GitBranchPlus, GitCommitHorizontal } from 'lucide-react'
import { useActiveBranchRecord } from '@axilon-apps/domains-ontology-ui-state'
import { Button } from '../ui/button'
import { BranchCommitDialog } from './BranchCommitDialog'
import { BranchCreateDialog } from './BranchCreateDialog'

/**
 * Topbar branch action. On a writable branch: "Commit" its working database.
 * On any protected branch (main, or a user-protected one): "Checkout", which
 * forks a new working branch off the protected branch at its head and
 * switches to it — protected branches advance only via merge, so there is
 * nothing to commit in place.
 */
export function BranchCommitButton() {
  // Resolve the active branch by id (page-independent), not by scanning the
  // paginated list — the active branch can sit off the newest-first first page.
  const active = useActiveBranchRecord()
  const [open, setOpen] = React.useState(false)

  const onBranch = active !== undefined && !active.protected

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        className="h-8 gap-1.5 text-xs"
        onClick={() => setOpen(true)}
      >
        {onBranch ? (
          <GitCommitHorizontal className="size-3.5" />
        ) : (
          <GitBranchPlus className="size-3.5" />
        )}
        {onBranch ? 'Commit' : 'Create Branch'}
      </Button>
      {onBranch ? (
        <BranchCommitDialog branch={active} open={open} onOpenChange={setOpen} />
      ) : (
        <BranchCreateDialog open={open} onOpenChange={setOpen} source={active} />
      )}
    </>
  )
}
